import { useLang } from "../context/LanguageContext";
import Seo from "../components/Seo";

const About = () => {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <Seo
        title="Über uns – Die tamilische Akademie der Schweiz"
        description="Lerne die Geschichte und Mission der KK Academy kennen. Tamilische Musik, Tanz und Kultur für die Schweizer Community."
        path="/ueber-uns"
      />
      <section className="py-24 max-w-4xl mx-auto px-6">
        <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">{t("footer.about")}</div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] mb-6">{t("about.title")}</h1>
        <p className="text-muted-foreground text-lg mb-10">{t("about.sub")}</p>
        <div className="prose prose-invert max-w-none space-y-6 text-foreground/90 leading-relaxed">
          <p>
            KK Academy ist das Kulturzentrum, das sich ganz dem Tanz, der Musik, aufregenden Events und der vielfältigen tamilischen Kultur verschrieben hat. Wir fördern musikalische und tänzerische Talente von Kindern, Jugendlichen und Erwachsenen, vernetzen unsere Mitglieder und unterstützen Projekte, die die tamilische Gemeinschaft in der Schweiz voranbringen.
          </p>
          <p>
            Unsere Akademie versteht sich als Brücke zwischen jahrtausendealter Tradition und zeitgenössischem Ausdruck. Wir glauben fest daran, dass Kultur die Seele einer Gemeinschaft ausmacht – und dass es unsere Verantwortung ist, sie lebendig, sichtbar und zugänglich zu halten.
          </p>
          <p>
            Die KK Academy bietet professionellen Unterricht in karnatischer Musik (Mirudangam, Violine, Veenai, Sangitham) sowie in Tanzformen wie Bollywood, Kuthu, HipHop und Performance Teams. Mit Workshops, Konzerten und Veranstaltungen schaffen wir eine Bühne für Gemeinschaft, Lernen und Begegnung.
          </p>
        </div>

        <div className="mt-12 card-academy rounded-lg p-6 max-w-md" data-testid="organisator-card">
          <div className="text-xs uppercase tracking-[0.3em] text-primary mb-2">Organisator & Gründer</div>
          <div className="font-serif-display text-2xl">Kokilan Kugathasan</div>
          <div className="text-sm text-muted-foreground mt-1">KK Academy – House of Dance & Music</div>
          <div className="text-xs text-muted-foreground mt-3">Wil SG · Schweiz</div>
        </div>
      </section>
    </div>
  );
};

export default About;
